import api from './index'

const axios = require('axios')

export default {
    login: (data) => {
        const path = '/login'

        return api.handling(axios.post(path, data))
    },

    self: () => {
        const path = '/users/self'

        return api.handling(axios.get(path))
    },

    logout: () => {
        const path = '/logout'

        return api.handling(axios.post(path))
    },

    requestPassword: (data) => {
        const path = '/password/request-reset'

        return api.handling(axios.post(path, data))
    },

    resetPassword: (data) => {
        const path = '/password/reset'

        return api.handling(axios.post(path, data))
    }
}
